import { EdgeMatchQrSignatureRepository } from '@/shared/infra/repositories'
import { makeSupabaseEdgeHttpClient } from '@/main/factories/http'
import type { MatchQrSignature } from '@/shared/domain/use-cases'

export function makeMatchQrSignature(): MatchQrSignature {
  return new EdgeMatchQrSignatureRepository(makeSupabaseEdgeHttpClient()).execute
}
